<template>
  <div
    @click="$store.commit('modals/OPEN_CHAT_BOT_POPUP', false)"
    class="py-3 md-pd flex items-end w-full h-full justify-end chatbot__modal__container"
  >
    <section
      @click.stop
      class="w-60 p-4 chatbot__modal__container__chat relative"
      :class="{ 'choose-skill__chat': !openiframe }"
    >
      <div
        @click="$store.commit('modals/OPEN_CHAT_BOT_POPUP', false)"
        class="flex absolute items-center justify-center cross-icon cursor-pointer z-20"
      >
        X
      </div>
      <iframe
        v-if="openiframe || validateItem"
        class="w-full h-full"
        :src="iFrameLink"
        frameBorder="0"
      ></iframe>
      <vue-perfect-scrollbar v-else class="overflow-container">
        <div v-if="!distributedItemSkeleton">
          <div class="choose-skill flex" v-if="items && items.length > 0">
            <div class="choose-skill__avatar w-100">
              <img
                :src="
                  require(`@/assets/images/bot/${activeSlug}/bot-avatar.png`)
                "
                class="w-24"
                alt=""
                @error="altChatBotImage"
              />
            </div>
            <h4 style="color: #91919f !important" class="text-left px-2">
              You can mark the status of the learning items you recently
              interacted with. After you mark it 'Done', you can validate the
              learning.
            </h4>
          </div>

          <div
            v-else-if="items && items.length === 0"
            class="choose-skill flex flex-col"
          >
            <div class="choose-skill__avatar w-1/3">
              <img
                :src="
                  require(`@/assets/images/bot/${activeSlug}/bot-avatar.png`)
                "
                class="w-3/4 md:w-full"
                alt=""
                @error="altChatBotImage"
              />
            </div>
            <h4 style="color: #91919f !important" class="text-left px-2 my-2">
              Hi {{ encodeURIComponent(`${userData.firstName}`) }}, Learning is
              a rewarding experience in itself. Additionally, to recognize your
              efforts in developing your skills, certain items may come with
              associated validations and claims.Currently, there are no items to
              share, but I will notify you as soon as I have some.
            </h4>
          </div>
        </div>

        <vs-row v-if="distributedItemSkeleton" class="px-3 pb-3">
          <vs-row
            v-for="i in 5"
            :key="i"
            class="p-8 skeleton rounded-lg my-2"
          />
        </vs-row>
        <!--  <div
          class="py-3"
          v-if="
            orgAndCourse && orgAndCourse.length > 0 && !distributedItemSkeleton
          "
        >
          <vs-row
            v-for="(org, index) in orgAndCourse"
            :key="index"
            class="px-2"
          >
            <h4 v-if="org && org.orgName" style="color: #91919f !important">
              Distributed by {{ org.orgName }}
            </h4>
            <vs-row
              v-if="
                org.courses &&
                org.courses.length > 0 &&
                !distributedItemSkeleton
              "
            >
              <vs-row
                class="my-2 items-center card p-3"
                v-for="(activity, index) in org.courses"
                :key="index"
              >
                <vs-col vs-w="2" class="flex">
                  <div class="h-12 w-12 overflow-none">
                    <img
                      v-if="activity && activity.imageUrl"
                      class="w-full h-full object-cover rounded-full"
                      :src="activity.imageUrl"
                      @error="randomFeedImage"
                    /></div
                ></vs-col>
                <vs-col vs-w="8">
                  <a
                    v-if="activity && activity.url"
                    :href="activity.url"
                    target="_blank"
                    ><h5 class="text-left cropped-text">
                      {{ activity.title | title }}
                    </h5></a
                  ></vs-col
                >
                <vs-col vs-w="2">
                  <vx-tooltip
                    text="Validate"
                    position="bottom"
                    class="tooltip-index"
                  >
                    <img
                      @click="validateForm(org.orgId, org.orgName, activity)"
                      class="cursor-pointer w-10 h-10 p-1 validate-icon"
                      src="@/assets/images/icons/fact_check.svg"
                      alt=""
                    />
                  </vx-tooltip>
                </vs-col>
                <vs-row class="justify-end"
                  ><div
                    class="validate-btn py-2 px-3 cursor-pointer"
                    @click="validateForm(org.orgId, org.orgName, activity)"
                  >
                    Validate
                  </div></vs-row
                > 
              </vs-row>
            </vs-row>
          </vs-row>
        </div> -->

        <div
          class="py-3"
          v-if="items && items.length > 0 && !distributedItemSkeleton"
        >
          <vs-row
            class="items-center card p-3 cursor-pointer"
            :class="items.length !== 1 ? 'mb-4' : ''"
            v-for="(item, index) in items"
            :key="index"
            @click.native="openLink(item)"
          >
            <vs-col vs-w="2" class="flex">
              <div class="h-12 w-12 overflow-none">
                <!-- v-if="item && item.imageUrl" -->
                <img
                  class="w-full h-full object-cover rounded-full"
                  :src="item.imageUrl ? item.imageUrl : randomFeedImage"
                  @error="randomFeedImage"
                /></div
            ></vs-col>
            <vs-col class="ml-1" vs-w="8">
              <div>
                <h5 class="text-left cropped-text">
                  {{ item.title | title }}
                </h5>
              </div></vs-col
            >

            <vs-row class="justify-end mt-2">
              <!-- validation btn  -->
              <vs-button
                v-if="item.status === 'done' && item.libraryItemValidationData"
                class="px-3 py-2"
                @click.native="validateForm(item)"
                >Validate</vs-button
              >
              <!-- ** doing done chips ** -->
              <vs-chip
                v-else
                class="mt-3 cursor-pointer"
                :class="item.type === 'article' ? 'hidden' : ''"
              >
                <vs-chip
                  class="text-black font-bold"
                  @click.native="
                    setDevelopmentStage({
                      status: 'doing',
                      itemId: item.itemId,
                      type: item.type,
                      index: index,
                    })
                  "
                  :color="item.status === 'doing' ? '#f2c244' : ''"
                  >Doing</vs-chip
                >
                <vs-chip
                  class="text-black font-bold"
                  @click.native="
                    setDevelopmentStage({
                      status: 'done',
                      itemId: item.itemId,
                      type: item.type,
                      index: index,
                    })
                  "
                  :color="item.status === 'done' ? '#f2c244' : ''"
                  >Done</vs-chip
                >
              </vs-chip>
            </vs-row>
          </vs-row>
        </div>
        <!-- <div v-else-if="!distributedItemSkeleton" class="mt-3">
          <h4 style="color: #91919f !important" class="text-left px-2">
            Tell us what you'd be most interested in
            <vs-icon
              icon="icon-arrow-right-circle"
              class="cursor-pointer"
              color="#f2c244"
              icon-pack="feather"
              size="25px"
              @click="openClaimForm"
            />
          </h4>
        </div> -->
      </vue-perfect-scrollbar>
    </section>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import chatBotForms from "@/assets/data/chatBotForms.js";
export default {
  name: "ChatBotModal",
  data() {
    return {
      openiframe: false,
      distributedItemSkeleton: true,
      activityDoneIds: [],
      orgAndCourse: [],
      selectedFormData: [],
      timeZone: "",
      formId: "",
      iFrameLink: "",
      items: [],
      chatBotForms,
      activeSlug: "default",
    };
  },
  components: {
    VuePerfectScrollbar,
  },
  computed: {
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    userData() {
      return this.$store.state.users.data;
    },
    userOrganization() {
      return this.$store.state.users.selectedOrganization;
    },
    validateItem() {
      return this.$store.state.users.validateItem;
    },
    itemToValidate() {
      return this.$store.state.users.itemToValidate;
    },
    accessToken() {
      return this.$store.state.auth.accessToken;
    },
  },
  watch: {
    itemToValidate: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          this.validateForm(newVal);
        }
      },
    },
    userOrganization: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && newVal.organizationData && newVal.organizationData.slug) {
          this.activeSlug = newVal.organizationData.slug;
        }
      },
    },
  },
  created() {
    this.fetchUserInterestedItems();
    this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  },
  methods: {
    handleChatBotPopup() {
      if (!this.openiframe) {
        this.$store.commit("user/OPEN_IFRAME", true);
      }
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    validateForm(activity) {
      event.stopPropagation();
      let orgData = this.userOrganizations.find(
        (obj) =>
          obj.organizationId ===
          activity.libraryItemValidationData.gtbrddOrganizationId
      );

      let selectedOrgFormConfig = this.chatBotForms.find(
        (obj) => obj.orgSlug === orgData.organizationData.slug
      );

      let formId;
      if (!selectedOrgFormConfig) {
        selectedOrgFormConfig = this.chatBotForms.find(
          (obj) => obj.orgSlug === "getboarded"
        );
        formId = selectedOrgFormConfig
          ? selectedOrgFormConfig.uploadFormId
          : "";
      } else {
        formId = selectedOrgFormConfig
          ? selectedOrgFormConfig.uploadFormId
          : "";
      }
      this.openiframe = true;
      this.iFrameLink = `https://chat.getboarded.com/quiz?name=${encodeURIComponent(
        `${this.userData.firstName} ${
          this.userData.lastName ? this.userData.lastName : ""
        }`
      )}&email=${this.userData.email}&orgSlug=${
        orgData.organizationData.slug
      }&organizationId=${orgData.organizationId}&quizId=${
        activity.itemId
      }&type=${activity.type}&userId=${this.userData._id}&token=${
        this.accessToken
      }&validationType=${activity.libraryItemValidationData.validationType}`;
      // else {
      //   this.iFrameLink = `https://gtbrdd.typeform.com/c/${formId}#first_name=${encodeURIComponent(
      //     `${this.userData.firstName}`
      //   )}&email=${this.userData.email}&org=${
      //     orgData.organizationData.name
      //   }&gbuid=${this.userData._id}&gborgid=${
      //     orgData.organizationId
      //   }&tzn=${encodeURIComponent(this.timeZone)}&learningid=${
      //     activity.itemId
      //   }&learningtitle=${activity.title}`;
      // }
    },
    // openClaimForm() {
    //   this.openiframe = true;
    //   this.formId = "n7isLdQI";
    //   this.iFrameLink = `https://gtbrdd.typeform.com/to/n7isLdQI#first_name=${encodeURIComponent(
    //     `${this.userData.firstName}`
    //   )}&email=${this.userData.email}&org=${
    //     this.userOrganizations[0].organizationData.name
    //   }&gbuid=${this.userData._id}&gborgid=${
    //     this.userOrganizations[0].organizationId
    //   }&tzn=${encodeURIComponent(this.timeZone)}`;
    // },
    fetchUserInterestedItems() {
      for (let i = 0; i < this.userOrganizations.length; i++) {
        this.distributedItemSkeleton = true;
        this.$store
          .dispatch("alex/getRedirectItemsCount", {
            gtbrddOrganizationId: this.userOrganizations[i].organizationId,
            gtbrddUserId: this.userData._id,
            source: ["LIBRARY"],
          })
          .then((res) => {
            if (res && res.data && res.data.length > 0) {
              let itemIds = [];
              let array1 = res.data;
              for (let element of res.data) {
                if (!itemIds.includes(element.feedItemId)) {
                  itemIds.push(element.feedItemId);
                }
              }
              this.$store
                .dispatch("feed/fetchBulkItemDetails", {
                  itemId: itemIds,
                  getboardedId: this.userData._id,
                })
                .then((res) => {
                  let array2 = res;
                  this.mergeArrays(array1, array2);
                  this.distributedItemSkeleton = false;
                })
                .catch((err) => {
                  this.distributedItemSkeleton = false;
                });

              if (res.data.length > 0) {
                let altfItems = [];
                for (let a = 0; a < res.data.length; a++) {
                  if (res.data[a].feedItemId.includes("altf")) {
                    const payload = {
                      orgId: "6512fc951aa789001abd5ed4",
                      itemId: res.data[a].feedItemId,
                      userId: this.userData._id,
                    };
                    this.$store
                      .dispatch("alex/fetchCustomLibraryItem", payload)
                      .then((res) => {
                        if (res.data) {
                          altfItems.push(res.data);
                          this.mergeArrays(this.items, altfItems);
                        }
                      })
                      .catch((err) => {
                        // console.log(err);
                      });
                  }
                }
              }
            } else {
              this.distributedItemSkeleton = false;
            }
          })
          .catch((err) => {
            this.distributedItemSkeleton = false;
          });
      }
    },
    setDevelopmentStage(i) {
      event.stopPropagation();
      const payload = {
        type: i.type,
        getboardedId: this.userData._id,
        itemId: i.itemId,
        status: i.status,
      };
      if (i.status === "doing" || i.status === "done") {
        if (i.status === "doing") {
          this.$store.commit("feed/ADD_DOING_ITEMS", this.items[i.index]);
          this.$vs.notify({
            color: "success",
            text: "You have marked this item in your 'doing' activity queue. Make sure to mark it 'done' when you are finished with it.",
            time: 5000,
          });
        }
        if (i.status === "done") {
          this.$vs.notify({
            color: "success",
            text: "Item marked done, moved to validation queue.",
            time: 5000,
          });
        }
      } else if (i.status === "do") {
        this.$vs.notify({
          color: "success",
          text: "You have marked your item back to 'do'. Would you like to drop a feedback? This may help us give better recommendations.",
          time: 5000,
        });
        this.queries = true;
      }
      this.$store
        .dispatch("feed/updateCourseStatus", payload)
        .then((res) => {
          const { index, status } = i;
          this.items[index].status = status;
          this.$forceUpdate();
        })
        .catch((err) => {
          // console.log(err);
        })
        .finally(() => {
          this.disableLink = false;
        });
    },
    openLink(item) {
      let link = `https://library.getboarded.com/redirect-page?itemId=${
        item.itemId
      }&type=${item.type || item.itemType}&gbuid=${this.userData._id}&gborgid=${
        this.userOrganization.organizationId
      }&redirectsourceid=USER_DASHBOARD`;
      if (link && !this.queries && !this.disableLink) {
        window.open(link, "_blank");
      }
    },
    mergeArrays(array1, array2) {
      const merged = [];
      const idSet = new Set();
      for (const item of array1) {
        merged.push(item);
        idSet.add(item.feedItemId);
      }
      for (const item of array2) {
        if (idSet.has(item.itemId)) {
          const existingItem = merged.find(
            (el) => el.feedItemId === item.itemId
          );
          Object.assign(existingItem, item);
        } else {
          merged.push(item);
          idSet.add(item.itemId);
        }
      }
      this.items = merged;
    },
    altChatBotImage(e) {
      return (e.target.src = require(`@/assets/images/bot/default/bot-avatar.png`));
    },
  },
};
</script>

<style lang="scss" scoped>
.cross-icon {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  top: 0;
  font-size: 1.5em;
  padding: 0.5em;
  border-radius: 50%;
  height: 2em;
  width: 2em;
  top: -0.5em;
  right: -0.5em;
  transition: all 0.23s ease 0.1s;
  transform: translate(8px, -2px);
  font-family: "Montserrat", Helvetica, Arial, serif;
  background: #fffffffa;
  // For hover effect of close btn
  &:hover,
  &:focus,
  &:active {
    opacity: 1;
    outline: none;
    transform: translate(5px, 3px);
    box-shadow: none;
  }
}
.skeleton {
  position: relative;
  margin: 2em 0;
  padding: 10em 0;
  border-radius: 10px;
  background: rgb(128, 128, 128);
  animation: flicker-light 1s infinite alternate;
}
@keyframes flicker-light {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.2;
  }
}
.b-dropdown ::v-deep .dropdown-toggle {
  white-space: normal;
}

.chatbot__modal {
  &__container {
    background: #0000006a;
    backdrop-filter: blur(5px);
    position: fixed !important;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 100000;
    &__chat {
      width: 25%;
      height: 75%;
      right: 2.75em;
      top: -2.5em;
      border-radius: 10px;
      background: #fff;
      .text {
        color: #1c1c1e;
      }
    }

    .vs-tooltip {
      z-index: 5200000;
    }
    .card {
      background: #ffffff;
      box-shadow: 6px 6px 29px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
    }
    .validate-btn {
      font-size: 1.2em;
      background: grey;
      color: #fff;
      border-radius: 10px;
    }
    .validate-icon {
      filter: invert(91%) sepia(34%) saturate(1988%) hue-rotate(321deg)
        brightness(99%) contrast(92%);
    }
    .choose-skill__chat {
      width: 25%;
      max-height: 27.5em;
      height: auto;
      // top: 17.5%;
    }

    .choose-skill {
      &__avatar {
        // width: 100%;
      }
      &__btns {
        .btn {
          padding: 1em;
          background-color: #82868b;
          color: #ffffff;
          width: 55%;
        }
      }
    }

    .overflow-container {
      max-height: 25em;
      overflow-y: scroll;
    }
  }
}

@media only screen and (max-width: 1400px) {
  .chatbot__modal {
    &__container {
      .choose-skill {
        &__btns {
          .btn {
            width: 70%;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .chatbot__modal {
    &__container {
      .choose-skill {
        &__chat {
          right: 2.75em;
          width: 32%;
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .md-pd {
    padding: 1.5em !important;
  }
  .chatbot__modal {
    &__container {
      &__chat {
        height: 50%;
        right: 0.5em;
        width: 50%;
      }

      .choose-skill {
        &__chat {
          width: 40%;
          right: 0.75em;
        }
        &__avatar {
          img {
            width: 50%;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .md-pd {
    padding: 1.5em !important;
  }
  .chatbot__modal {
    &__container {
      .choose-skill {
        &__chat {
          width: 50%;
          max-height: 75%;
          height: auto;
        }
      }
    }
  }
}

@media only screen and (max-width: 660px) {
  .chatbot__modal {
    &__container {
      // &__chat {
      //   width: 95%;
      //   height: 75%;
      //   top: 3.5em;
      // }

      .choose-skill__chat {
        width: 95%;
      }
      .choose-skill {
        &__avatar {
          img {
            width: 25%;
          }
        }
      }
    }
  }
}
</style>
